import { render } from "./sevenDayNotif.vue?vue&type=template&id=ba5f645a"
import script from "./sevenDayNotif.vue?vue&type=script&lang=js"
export * from "./sevenDayNotif.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__